// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"styles_carouselContainer__Bw75G"};